import { formatDate, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { HorseRacingService } from 'src/app/services/horse-racing.service';
import { RouterFlowService } from 'src/app/shared/services/router-flow.service';
import { SettingsService } from '../../services/settings.service';
@Component({
  selector: 'app-quarte-races',
  templateUrl: './quarte-races.component.html',
  styleUrls: ['./quarte-races.component.scss'],
})
export class QuarteRacesComponent implements OnInit, OnDestroy {
  @Output() raceDetailsEvent = new EventEmitter();

  private subscription: Subscription;
  nextQuarteRaces;
  races;
  today; tomorrow; yesterday;
  format = 'yyyy-MM-dd';
  locale = 'en-US';
  loading = true;


  get quarteRaces(): any {
    return this.nextQuarteRaces
  }

  @Input() collapsed = false;

  constructor(
    public router: Router,
    private horseRacingService: HorseRacingService,
    private routerFlowService: RouterFlowService,
    private authService: AuthService,
    private settingServ: SettingsService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.authService.currentAuthStatus.subscribe((authStatus) => {
      if (!authStatus && this.subscription) {
        this.subscription.unsubscribe();
      }
    });
  }

  ngOnInit(): void {
    this.loading = true;
    this.getQuarteRacesData();
  }

  getQuarteRacesData(): void {
    const data =
    {
      raceTypes: ["pmu_quarte_plus"],
      dateTime: formatDate(new Date(), this.format, this.locale)
    }

    this.horseRacingService.getQuarteRaces(data)
      .pipe(
        tap((values) => {
          this.races = values.filter((race) => !this.settingServ.filterRaceCountries(race.racePath.split("/")[1]))
          this.setLocalDate(this.races);
          if (isPlatformBrowser(this.platformId)) {
            this.subscription = interval(60000).subscribe(x => { this.getTimeDifference(); });
            this.nextQuarteRaces = this.races.slice(0, 4);
            this.loading = false;
          }
        })
      ).subscribe();
  }

  setLocalDate(races): void {
    for (const race of races) {
      const startTimeUtc = race.StartTimeUtcTimestamp ? new Date(race.StartTimeUtcTimestamp * 1000) : undefined;
      const scheduleTimeUtc = race.ScheduleTimeUtcTimestamp ? new Date(race.ScheduleTimeUtcTimestamp * 1000) : undefined;
      const localDate = (startTimeUtc !== undefined) ? startTimeUtc : scheduleTimeUtc;
      race.localDatetime = localDate !== null ? localDate : '';
      const startTime = new Date();
      const difference = race.localDatetime.getTime() - startTime.getTime();
      race.dateDiffMin = Math.round(difference / 60000);
      race.dateDiffHour = Math.round(difference / (60000 * 60));
    }
  }

  getTimeDifference(): void {
    for (const race of this.races) { this.getRaceTimeDifference(race); }
    this.nextQuarteRaces = this.races.slice(0, 4);
  }

  getRaceTimeDifference(race: any): void {
    const startTime = new Date();
    const difference = race.localDatetime.getTime() - startTime.getTime();
    race.dateDiffMin = Math.round(difference / 60000);
    race.dateDiffHour = Math.round(difference / (60000 * 60));
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  goToRaceDetails(race): void {
    this.routerFlowService.sendRedirectInfo();
    const urlPath = '/race/' + race.racePath;

    this.router.navigateByUrl('/race', { skipLocationChange: true }).then(() =>
      this.router.navigate([urlPath]))

  }

  getRaceType(race): 'Trot' | 'Gallop' | 'Greyhound' {
    return race.IsTrot ? 'Trot' : race.IsGallop ? 'Gallop' : 'Greyhound';
  }

}
